module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAxMCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMzRMOS4zMzAxMyAyNi41TDAuNjY5ODcyIDI2LjVMNSAzNFpNNC4yNSAtMy4yNzgzNWUtMDhMNC4yNSAyNy4yNUw1Ljc1IDI3LjI1TDUuNzUgMy4yNzgzNWUtMDhMNC4yNSAtMy4yNzgzNWUtMDhaIiBmaWxsPSIjNTE1MTUxIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arrow-down.svg
// module id = 1eTL
// module chunks = 134